import {createContext, use} from 'react'
import {type HgFilterContextType} from './types'

export const HgFilterContext = createContext<HgFilterContextType | null>(null)

export function useHgFilterTabContext() {
  const context = use(HgFilterContext)
  if (!context) {
    throw new Error('useHgFilterTabContext must be used within a HgFilter')
  }
  return context
}
